import palette from '~/theme/dark/palette'

export default {
  styleOverrides: {
    root: {
      backgroundColor: palette.background.dark
    }
  }
}
